import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";
import SearchModule from "../components/SearchModule";
import AccommodationCard from "../components/AccommodationCard";
import BookingDialog from "../components/BookingDialog";
import Reveal from "../components/Reveal";

export default function SearchResults() {
  const { t } = useI18n();
  const { settings } = useSite();
  const [params] = useSearchParams();
  const [results, setResults] = useState(null);
  const [booking, setBooking] = useState(null);

  const arrivee = params.get("arrivee") || "";
  const depart = params.get("depart") || "";
  const voyageurs = Number(params.get("voyageurs") || 2);
  const adultes = Number(params.get("adultes") || voyageurs);
  const enfants = Number(params.get("enfants") || 0);
  const type = params.get("type") || "";

  const run = useCallback(() => {
    api.post("/search", { arrivee, depart, voyageurs, type: type || null })
      .then((r) => setResults(r.data)).catch(() => setResults({ results: [], count: 0 }));
  }, [arrivee, depart, voyageurs, type]);

  useEffect(() => { run(); }, [run]);

  const prefill = { arrivee, depart, voyageurs, adultes, enfants };
  const dateQuery = (arrivee && depart)
    ? `?arrivee=${arrivee}&depart=${depart}&voyageurs=${voyageurs}&adultes=${adultes}&enfants=${enfants}`
    : "";

  return (
    <div>
      <section className="relative pt-20 lg:pt-28">
        <div className="relative h-[38vh] min-h-[280px] overflow-hidden">
          <img src={settings.hero_image} alt="Disponibilités et réservation — Domaine de la Bégaudière, Mont-Saint-Michel" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
          <div className="absolute inset-0 flex items-center">
            <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8">
              <h1 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl font-medium">{t("searchPage.title")}</h1>
            </div>
          </div>
        </div>
        <div className="relative -mt-16 px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-5xl"><SearchModule variant="page" /></div>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {results === null ? (
            <p className="text-center text-ink-400">{t("common.loading")}</p>
          ) : results.count === 0 ? (
            <div className="text-center py-16">
              <p className="text-ink-600 font-body text-lg max-w-md mx-auto">{t("searchPage.noResults")}</p>
            </div>
          ) : (
            <>
              <p className="text-ink-600 font-body mb-8"><span className="font-semibold text-ink-900">{results.count}</span> {t("searchPage.resultsFor")}</p>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {results.results.map((a, i) => (
                  <Reveal key={a.id} delay={(i % 3) * 80} className="h-full"><AccommodationCard item={a} onBook={setBooking} dateQuery={dateQuery} /></Reveal>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      <BookingDialog item={booking} prefill={prefill} open={!!booking} onOpenChange={(v) => !v && setBooking(null)} />
    </div>
  );
}
